import { css } from '@ni/fast-element';
import { display } from '../../utilities/style/display';

export const styles = css`
    ${display('none')}
`;
